var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83069",
    "data-name": "Group 83069",
    transform: "translate(-353 -1943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23092",
    "data-name": "Path 23092",
    d: "M795.858,0a19,19,0,1,1-19,19,19,19,0,0,1,19-19",
    transform: "translate(-423.858 1943)",
    fill: "#cdcdcd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23093",
    "data-name": "Path 23093",
    d: "M988.856,153.444c-5.292-.318-4.3,1.793-4.356,5.173l4.176.006c-.265,1.711-.613,3.958-.671,4.332l-3.5.013c.009,3.5.043,7.026-.011,10.522-.489.057-1.914.1-2.2.1-.824-.022-1.958-.066-2.559-.1,0-1.881.069-8.783.068-10.532-.938,0-2.616.009-3.823-.006,0-.88-.015-2.81,0-4.335.685-.017,3.039,0,3.832-.026,0-.981-.005-1.929-.008-3.173-.012-4.389,2.856-6.9,9.053-5.659,0,1.036,0,2.923,0,3.688",
    transform: "translate(-609.971 1800.561)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social_facebook.8c2a57430f464a111815d41e96d075fe.svg";
export { ForwardRef as ReactComponent };